import { motion } from "framer-motion";
export const SlideInFromLeft = ({
  children,
  show,
}: {
  children: React.ReactNode;
  show: boolean;
}) => {
  const phoneInputVariants = {
    hidden: { x: "-100%", opacity: 0, height: 0 },
    visible: { x: 0, opacity: 1, height: "auto" },
  };

  const phoneInputTransition = {
    type: "spring",
    stiffness: 300,
    damping: 25,
  };

  return (
    <motion.div
      initial="hidden"
      animate={show ? "visible" : "hidden"}
      variants={phoneInputVariants}
      transition={phoneInputTransition}
    >
      {children}
    </motion.div>
  );
};
